'use client';

import { c as _c } from "react/compiler-runtime";
import { Divider } from '@common/components';
import { cn } from '@core/utils';
import type { ReactNode } from 'react';
import type { PriceItem } from './PriceList';
import { PriceList } from './PriceList';
interface InfoItem {
  label: ReactNode;
  content: ReactNode;
}
interface BenefitItem {
  label: string;
  value: string;
}
interface PriceSectionProps {
  prices: PriceItem[];
  infos: InfoItem[];
  couponButton?: ReactNode;
  benefitItems?: BenefitItem[];
  maxDiscountAmount?: string;
  isBenefitOpen?: boolean;
  onBenefitToggle?: () => void;
}
export const PriceSection = t0 => {
  const $ = _c(21);
  const {
    prices,
    infos,
    couponButton,
    benefitItems,
    maxDiscountAmount,
    isBenefitOpen,
    onBenefitToggle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex items-end justify-between gap-4", "mobile-tablet:items-start mobile-tablet:px-20");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isBenefitOpen || $[2] !== onBenefitToggle || $[3] !== prices) {
    t2 = <PriceList prices={prices} isBenefitOpen={isBenefitOpen} onBenefitToggle={onBenefitToggle} />;
    $[1] = isBenefitOpen;
    $[2] = onBenefitToggle;
    $[3] = prices;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== couponButton || $[6] !== t2) {
    t3 = <div className={t1}>{t2}{couponButton}</div>;
    $[5] = couponButton;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== benefitItems || $[9] !== isBenefitOpen || $[10] !== maxDiscountAmount) {
    t4 = isBenefitOpen && benefitItems && benefitItems.length > 0 && <div className="mx-0 bg-Gray-25 p-16 mobile-tablet:mx-20"><p className="font-700 text-Gray-900 typo-body4">최대 할인 적용받을 시</p><div className="mt-8 flex flex-col gap-8">{benefitItems.map(_temp)}{maxDiscountAmount && <div className="flex items-center justify-between"><span className="font-700 text-O-400 typo-body4">최대 할인 금액</span><span className="font-700 text-O-400 typo-body4">{maxDiscountAmount}</span></div>}</div></div>;
    $[8] = benefitItems;
    $[9] = isBenefitOpen;
    $[10] = maxDiscountAmount;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== infos.length) {
    t5 = infos.length > 0 && <div className="mobile-tablet:px-20"><Divider className="!bg-Gray-700" /></div>;
    $[12] = infos.length;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== infos) {
    t6 = infos.length > 0 && <div className={cn("flex flex-col gap-8", "mobile-tablet:px-20")}>{infos.map(_temp2)}</div>;
    $[14] = infos;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div className="flex flex-col gap-28 mobile-tablet:gap-20">{t3}{t4}{t5}{t6}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
function _temp(item) {
  return <div key={item.label} className="flex items-center justify-between"><span className="font-400 text-Gray-700 typo-body4">{item.label}</span><span className="font-400 text-Gray-700 typo-body4">{item.value}</span></div>;
}
function _temp2(info, index) {
  return <div key={index} className="flex items-start gap-16"><div className="w-[92px] shrink-0 font-500 text-Gray-900 typo-body4">{info.label}</div><div className="flex-1">{info.content}</div></div>;
}